import * as configuration from '@appStore/configuration/actions/configuration.actions';

export * from '@appStore/configuration/actions/configuration.actions';

export const ActionTypes = {
  ...configuration.ConfigurationActionTypes
};

export type Actions = configuration.ConfigurationActions;
